import { OAuthProvider } from '@angular/fire/auth';

/** Creates the Firebase provider used for Sign in with Apple. */
export function createAppleAuthProvider(): OAuthProvider {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');
  return provider;
}
